import { Api, ApiMethod } from "../../components/common/ApiLinkedButton";
import { admiApiLinkConstants } from "../../constants";
import {
  PaymentReleaseRequestsResponse,
  PaymentReleaseRequestStatus,
} from "./PaymentReleaseRequest.model";

export class PaymentReleaseRequestAdminApi {
  public static getAllPRRs(
    status?: PaymentReleaseRequestStatus
  ): Promise<PaymentReleaseRequestsResponse> {
    let api = admiApiLinkConstants.API_ADMIN_PAYMENT_RELEASE_REQUESTS_ALL;
    if (status) {
      api += "?status=" + status;
    }
    return new Api<void, PaymentReleaseRequestsResponse>(
      api,
      ApiMethod.GET
    ).executeV2();
  }
}
